var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.8,5.4l0.8,0.8l-8.1,8.1H1.8v-0.8L9.8,5.4z M13,0c-0.2,0-0.5,0.1-0.6,0.3l-1.6,1.6l3.3,3.3l1.6-1.6c0.3-0.3,0.3-0.9,0-1.3\n\tl-2.1-2.1C13.5,0.1,13.3,0,13,0z M9.8,2.8L0,12.7V16h3.3l9.8-9.8L9.8,2.8z","fill":"currentColor"}));
}

Edit.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Edit;

Edit.default = Edit;
